import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import LayoutComponent from "./LayoutComponent";
import routes from "./routes";
import PublicRoute from "./PublicRoute";
import ScrollToTop from "../components/ScrollToTop";

const Routers: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {routes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            element={
              <LayoutComponent layoutType={route.layoutType}>
                {route.isPrivate ? (
                  <PrivateRoute path={route.path} element={route.element} />
                ) : (
                  <PublicRoute path={route.path} element={route.element} />
                )}
              </LayoutComponent>
            }
          />
        ))}
      </Routes>
    </>
  );
};

export default Routers;
